import { useState, useCallback, useEffect } from "react";

const STORAGE_KEY = "tripui-map-layers";

const LAYER_DEFAULTS = {
  cameras: true,
  roadWork: true,
  incidents: true,
};

/**
 * Manages map layer visibility state with localStorage persistence.
 * Returns the current visibility map and a toggle function.
 */
const useMapLayers = () => {
  const [layers, setLayers] = useState(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (stored) {
        const parsed = JSON.parse(stored);
        // Merge with defaults so new layers added later get their default
        return { ...LAYER_DEFAULTS, ...parsed };
      }
    } catch {
      // ignore parse errors
    }
    return { ...LAYER_DEFAULTS };
  });

  // Persist to localStorage on every change
  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(layers));
    } catch {
      // ignore storage errors
    }
  }, [layers]);

  const toggleLayer = useCallback((layerId) => {
    setLayers((prev) => ({ ...prev, [layerId]: !prev[layerId] }));
  }, []);

  const setLayerVisible = useCallback((layerId, visible) => {
    setLayers((prev) => ({ ...prev, [layerId]: visible }));
  }, []);

  return { layers, toggleLayer, setLayerVisible };
};

export default useMapLayers;
